import { gql } from "@apollo/client";

export const UPDATE_VIS_ABANDONED = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        abandoned
      }
    }
  }
`;
export const UPDATE_VIS_IMPOUNDED = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        impounded
      }
    }
  }
`;
export const UPDATE_VIS_OPERATOR = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        incident {
          id
        }
        operator {
          id
        }
        vehicle {
          id
        }
      }
    }
  }
`;
export const UPDATE_VIS_REASON_SEIZED = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        reasonSeized {
          id
          oriId
          position
          name
        }
      }
    }
  }
`;
export const UPDATE_VIS_SUSPECT_DRIVEN = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        suspectDriven
      }
    }
  }
`;
export const UPDATE_VIS_WRECKER = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        wrecker {
          id
          oriId
          position
          name
        }
      }
    }
  }
`;
export const UPDATE_VIS_TOWING_DESTINATION = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        towingDestination {
          id
          oriId
          position
          name
        }
      }
    }
  }
`;
export const UPDATE_VIS_USED_IN_CRIME = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        usedInCrime
      }
    }
  }
`;

export const UPDATE_VIS_VEHICLE_OF_INTEREST = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        vehicleOfInterest
      }
    }
  }
`;
export const UPDATE_VIS_VEHICLE_ROLE = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        vehicleRole {
          id
          oriId
          position
          name
        }
      }
    }
  }
`;
export const UPDATE_VIS_POSITION = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        id
        uuid
        position
      }
    }
  }
`;

export const ADD_OR_UPDATE_VEHICLE_IN_INCIDENT = gql`
  mutation addOrUpdateVehicleInIncident(
    $input: AddOrUpdateVehicleInIncidentInput!
  ) {
    addOrUpdateVehicleInIncident(input: $input) {
      errors
      incidentUuid
      vehicleIncidentSpecificUuid
      vehicleUuid
      vehicleIncidentSpecific {
        uuid
        id
        abandoned
        impounded
        operator {
          id
        }
        reasonSeized {
          id
          oriId
          position
          name
        }
        suspectDriven
        wrecker {
          id
          oriId
          position
          name
        }
        towingDestination {
          id
          oriId
          position
          name
        }
        usedInCrime
        vehicle {
          id
          uuid
          description
          owner {
            id
          }
          plateType {
            id
            oriId
            name
            position
          }
          value
          vehicleColor {
            id
            oriId
            name
            position
          }
          vehicleMake {
            id
            nhtsaId
            oriId
            name
            position
          }
          vehicleModel {
            id
            nhtsaId
            oriId
            name
            position
          }
          vehiclePlate {
            id
            oriId
            name
            position
          }
          vehicleState {
            id
            oriId
            name
            position
          }
          vehicleVin {
            id
            oriId
            name
            position
          }
          validVehicleAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            vehicle {
              id
            }
          }
          year
        }
        vehicleOfInterest
        vehicleRole {
          id
          oriId
          position
          name
        }
      }
    }
  }
`;
